/**
 * Instantiate dealer sorting functionality.
 */
(function () {
  const container = document.querySelector('[data-sortable]');

  if (container && typeof componentEvents !== 'undefined') {
    componentEvents.on('select-tooltip-changed', sortItems);
  }

  /**
   * Sort items in `container`, skipping the ones marked as such. Skipped items
   * are always pushed to the bottom.
   */
  function sortItems (data) {
    // If this is not the sorter element, do nothing.
    if (data.select.id !== 'select-dealer-sorter') return;

    const items = Array.from(container.querySelectorAll('[data-sortable-item]'));

    // We sort two different ways: alphabetically (ascending or descending) or
    // nummerically (always descending).
    switch (data.select.value) {

      // Sort items alphabetically.
      case 'name-ascending':
      case 'name-descending':
        // If name-based, sort using the data-sortable-item-name attribute.
        const ascending = data.select.value === 'name-ascending';
        items.sort(function (a, b) {
          let result;
          const valueA = a.dataset.sortableItemName;
          const valueB = b.dataset.sortableItemName;
          // We skip items marked for skipping. These items go to the bottom.
          const skipA = a.dataset.sortableItemSkip === 'true';
          const skipB = b.dataset.sortableItemSkip === 'true';
          if (skipA || skipB) {
            result = skipA && skipB ? 0 : (skipA ? 1 : -1);
          } else if (ascending) {
            result = valueA === valueB ? 0 : (valueA > valueB ? 1 : -1);
          } else {
            result = valueA === valueB ? 0 : (valueA < valueB ? 1 : -1);
          }
          return result;
        });
        break;

      // Sort items numerically.
      default:
        // If not name-based, treat as numeric values.
        const attribute = 'data-sortable-item-' + data.select.value;

        items.sort(function (a, b) {
          let result;
          const valueA = parseInt(a.getAttribute(attribute) || 0);
          const valueB = parseInt(b.getAttribute(attribute) || 0);
          // We skip items marked for skipping. These items go to the bottom.
          const skipA = a.dataset.sortableItemSkip === 'true';
          const skipB = b.dataset.sortableItemSkip === 'true';
          if (skipA || skipB) {
            result = skipA && skipB ? 0 : (skipA ? 1 : -1);
          } else {
            // We sort numeric values in descending order.
            result = valueA === valueB ? 0 : (valueA < valueB ? 1 : -1);
          }
          return result;
        });
        break;
    }

    // Reorder elements in the DOM by appending them to the container.
    items.forEach(function (item) {
      container.appendChild(item);
    });
  }
})();

/**
 * Instantiate mobile-only tooltip functionality.
 */
(function () {
  const tooltip = document.querySelector('[data-mobile-tooltip]');
  const toggle = document.querySelector('[data-mobile-tooltip-toggle]');

  if (tooltip && toggle) {
    init();
  }

  /**
    * Attach resize handler to window and build tooltip if mobile.
    */
  function init () {
    window.addEventListener('resize', debounce(function (event) {
      isMobile() ? buildTooltip() : tearDownTooltip();
    }));

    if (isMobile()) {
      buildTooltip();
    }
  }

  /**
   * Update the DOM to display filter options in a tooltip UI.
   */
  function buildTooltip () {
    // If already turned into a tooltip, do nothing.
    if (tooltip.hasAttribute('[data-mobile-tooltip-enabled]')) return;

    tooltip.classList.add('tooltip');
    tooltip.setAttribute('aria-hidden', true);
    tooltip.setAttribute('data-mobile-tooltip-enabled', '');

    toggle.setAttribute('role', 'button');
    toggle.setAttribute('aria-expanded', false);
    toggle.setAttribute('aria-controls', tooltip.id);
    toggle.addEventListener('click', toggleTooltip);
    toggle.setAttribute('data-mobile-tooltip-enabled', '');
  }

  /**
   * Reset DOM to original state, thus removing tooltip UI.
   */
  function tearDownTooltip () {
    tooltip.classList.remove('tooltip');
    tooltip.removeAttribute('aria-hidden');
    tooltip.removeAttribute('data-mobile-tooltip-enabled');

    toggle.removeAttribute('role');
    toggle.removeAttribute('aria-expanded');
    toggle.removeAttribute('aria-controls');
    toggle.removeAttribute('data-mobile-tooltip-enabled');
    toggle.removeEventListener('click', toggleTooltip);
  }

  /**
   * Toggle expanded/collapsed state of the tooltip.
   */
  function toggleTooltip () {
    toggle.getAttribute('aria-expanded') === 'true' ? collapse() : expand();
  }

  /**
   * Collapse (hide) the tooltip.
   */
  function collapse () {
    tooltip.setAttribute('aria-hidden', true);
    toggle.setAttribute('aria-expanded', false);
  }

  /**
   * Expand (show) the tooltip.
   */
  function expand () {
    tooltip.setAttribute('aria-hidden', false);
    toggle.setAttribute('aria-expanded', true);
  }
})();

/**
 * Instantiate dealer attribute highlighting functionality.
 */
(function () {
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('filtering-options-changed', updateDealerAttributes);
  }

  /**
   * Update every highlightable item’s attributes to mark the ones that
   * correspond to checked filter options.
   */
  function updateDealerAttributes (data) {
    // Find all elements with a data-highlight-* attribute corresponding to
    // the changed option’s value.
    document.querySelectorAll('[data-highlight-' + data.changed.value + ']')
      .forEach(function (item) {
        // Set each item’s data-highlighted attribute according to the
        // option’s checked/unchecked status.
        item.setAttribute('data-highlighted', data.changed.checked);
      });
  }
})();

/**
 * Instantiate filter count funcitonality.
 */
(function () {
  const label = document.querySelector('.select-dealer__options-label');
  // If no label found, exit early.
  if (!label) return;

  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('filtering-options-changed', updateFilterCount);
  }

  /**
   * Count the number of filters currently enabled and print them on the DOM.
   */
  function updateFilterCount (data) {
    // Set the label’s data-filtering-count attribute to the length of the
    // options array filtered by the ones that are checked.
    label.setAttribute('data-filtering-count',
      data.options.filter((option) => option.checked).length);
  }
})();
